import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cleared } from "../../features/filter/filterSlice";
import { fetchTags } from "../../features/tags/tagsSlice";
import Tag from "./Tag";

export default function Tags() {
    const { tags } = useSelector((state) => state.tags);

    const filters = useSelector((state) => state.filter);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTags());
    }, [dispatch]);

    const clearHandler = () => {
        dispatch(cleared([]));
    };

    let btn;

    if (
        filters?.tags.length !== 0 ||
        filters?.search !== "" ||
        filters?.author !== ""
    ) {
        btn = (
            <button
                onClick={clearHandler}
                className="h-8 px-4 rounded bg-red-200 text-red-600 text-sm hover:bg-red-100 duration-200 text-white"
            >
                Clear Filter
            </button>
        );
    }

    return tags?.length > 0 ? (
        <section>
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 border-b flex justify-between">
                <div className="inline-flex gap-4">
                    {tags.map((tag) => (
                        <Tag key={tag.id} title={tag.title} />
                    ))}
                </div>
                {btn}
            </div>
        </section>
    ) : null;
}
